import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2727fcd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-s1" }
const _hoisted_2 = {
  key: 1,
  class: "flex align-items-end justify-content-around mt-s10 mx-s4"
}
const _hoisted_3 = {
  key: 0,
  class: "crosschain-label"
}
const _hoisted_4 = { class: "mb-s5 sm:mb-s7 route-axis" }
const _hoisted_5 = { class: "route" }
const _hoisted_6 = { class: "route-token" }
const _hoisted_7 = { class: "token-symbol" }
const _hoisted_8 = {
  key: 0,
  class: "route-step"
}
const _hoisted_9 = {
  key: 0,
  class: "crosschain-label my-s1"
}

import { useSwap } from '@/store/modules/swap/useSwap';
import { useSwapInfo } from '@/store/modules/swap/useSwapInfo';
import TokenIcon from '@/components/token/TokenIcon.vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PanelCollapse from '@/components/PanelCollapse.vue';
import Caption from '@/components/Caption.vue';
import { useStore } from 'vuex';
import InfoMessage from '@/components/InfoMessage.vue';
import ExternalLink from '@/components/ExternalLink.vue';
import { ENABLE_FAKE_CARDANO_NETWORK } from '@/helpers/fakeCardanoNetwork';
import { WSC_LEARN_MORE } from '@/constants/EXTERNAL_LINKS';


export default /*#__PURE__*/_defineComponent({
  __name: 'SwapRoute',
  setup(__props) {

const { swapForm } = useSwap();
const { swapInfo } = useSwapInfo();
const { t } = useI18n();
const { state } = useStore();

const wrappingMode = computed(() => {
  if (ENABLE_FAKE_CARDANO_NETWORK && swapForm.isSwapSameTokensFromMilkomedaToCardano) {
    return t('swap.swapInfo.unwrapping');
  }

  return swapForm.input?.token?.isETHToken()
    ? t('swap.swapInfo.wrapping')
    : t('swap.swapInfo.unwrapping');
});
const swapRoute = computed(() => [
  {
    token: swapForm.input?.token,
    wrappingMode: swapInfo.route.path.length === 1 ? wrappingMode.value : null,
    portfolioName: swapInfo.route.path[0]?.portfolioName,
  },
  ...swapInfo.route.path.slice(1, -1).map(item => {
    return {
      token: item.token.unwrapWETH(),
      wrappingMode: null,
      portfolioName: item.portfolioName,
    };
  }),
  { token: swapForm.output?.token },
]);
const iconSize = index => (index !== 0 && index !== swapRoute.value.length - 1 ? '24' : '32');
const routeSteps = computed(() => {
  let steps: Array<any> = [];
  if (swapRoute.value) {
    swapRoute.value.forEach((item, index) => {
      if (index < swapRoute.value.length - 1) {
        steps.push({
          stepInfo: item.wrappingMode ?? item.portfolioName,
          isCrosschain: index === +swapForm.bestTrade.route.crossChainPortfolioIndex,
        });
      }
    });
  }
  return steps;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PanelCollapse, {
    "panel-class": "panel-outlined",
    collapsed: ""
  }, {
    header: _withCtx(() => [
      _createVNode(Caption, {
        caption: _unref(t)('swap.swapInfo.route.caption'),
        tooltip: _unref(t)('swap.swapInfo.route.tooltip')
      }, null, 8, ["caption", "tooltip"])
    ]),
    default: _withCtx(() => [
      (_unref(ENABLE_FAKE_CARDANO_NETWORK))
        ? (_openBlock(), _createBlock(InfoMessage, {
            key: 0,
            type: "info",
            "as-panel": "",
            icon: "none",
            class: "mt-s4"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('swap.infoMessage.swapsVia')), 1),
              _createVNode(ExternalLink, {
                label: _unref(t)('readMore'),
                url: _unref(WSC_LEARN_MORE),
                color: "info"
              }, null, 8, ["label", "url"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_unref(state).layout.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routeSteps), (step) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "route-step",
                key: step.stepInfo
              }, [
                _createTextVNode(_toDisplayString(step.stepInfo) + " ", 1),
                (step.isCrosschain)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('swap.swapInfo.crosschain')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(swapRoute), (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(TokenIcon, {
                  "icon-src": item.token?.tokenIconUrl,
                  "chain-id": item.token?.chainId,
                  symbol: item.token?.symbol,
                  size: iconSize(index)
                }, null, 8, ["icon-src", "chain-id", "symbol", "size"]),
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.token?.symbol), 1)
              ]),
              (_unref(state).layout.isMobile && _unref(routeSteps)[index])
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(_unref(routeSteps)[index].stepInfo), 1),
                    (_unref(routeSteps)[index].isCrosschain)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("span", null, _toDisplayString(_unref(t)('swap.swapInfo.crosschain')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})